import { z } from 'zod';
export const MismatchDetailSchema = z.object({
    is_mismatch: z.boolean(),
    summary: z.string(),
    evidence: z.array(z.string())
});
export const CrossDatasetMismatchesSchema = z.object({
    pricing_mismatch: MismatchDetailSchema,
    geography_mismatch: MismatchDetailSchema,
    traffic_vs_volume: MismatchDetailSchema,
    mcc_vs_content: MismatchDetailSchema,
    descriptor_vs_brand: MismatchDetailSchema,
    policy_vs_behavior: MismatchDetailSchema,
    content_vs_transactions: MismatchDetailSchema
}).meta({
    id: 'CrossDatasetMismatches'
});

//# sourceMappingURL=cross-dataset-mismatches.schema.js.map